export default __webpack_public_path__ + "static/media/portrait.0da8337f.jpg";